var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"green-background"},[_c('NavBar'),_c('MainSlider'),_c('LinesOfActivity'),_c('HumanResources'),_c('Footer'),_c('go-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }